/**
 * Formats a given number as currency.  eg. 6999 => £6,999
 * @param {Number} value
 */
export const money = value => '£' + value.toLocaleString('en-GB', { maximumFractionDigits: 2 });
